/* ==========================================================
   LUXURY HEADER JS
   PART 5
   ========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================================
     STICKY HEADER - Using JavaScript
     ========================================================== */

  const header = document.querySelector('.luxury-header');
  const headerWrapper = document.querySelector('.luxury-header-wrapper');

  if (header && headerWrapper) {

    let headerHeight = header.offsetHeight;
    let isSticky = false;

    const handleHeaderScroll = () => {

      if (window.scrollY > 0 && !isSticky) {
        header.style.position = 'fixed';
        header.style.top = '0';
        header.style.left = '0';
        header.style.right = '0';
        header.style.zIndex = '95';
        header.classList.add('scrolled');
        headerWrapper.style.paddingTop = headerHeight + 'px';
        isSticky = true;

      } else if (window.scrollY <= 0 && isSticky) {
        header.style.position = '';
        header.style.top = '';
        header.style.left = '';
        header.style.right = '';
        header.style.zIndex = '';
        header.classList.remove('scrolled');
        headerWrapper.style.paddingTop = '';
        isSticky = false;
      }

    };

    handleHeaderScroll();

    window.addEventListener('scroll', handleHeaderScroll, {
      passive: true
    });

    // Recalculate height on resize
    window.addEventListener('resize', () => {
      headerHeight = header.offsetHeight;
      if (isSticky) {
        headerWrapper.style.paddingTop = headerHeight + 'px';
      }
    });

  }

  /* ==========================================================
     ANNOUNCEMENT SLIDER
     ========================================================== */

  const slider = document.querySelector('.luxury-announcement-slider');

  if (slider) {

    const slides = slider.querySelectorAll('.luxury-slide');
    const nextBtn = document.querySelector('.luxury-next');
    const prevBtn = document.querySelector('.luxury-prev');

    if (slides.length > 1) {

      let current = 0;
      let autoplay;

      slides.forEach((slide, index) => {

        slide.style.display =
          index === 0 ? 'block' : 'none';

      });

      const showSlide = (index) => {

        slides.forEach((slide) => {

          slide.style.display = 'none';
          slide.style.opacity = '0';

        });

        slides[index].style.display = 'block';

        requestAnimationFrame(() => {
          slides[index].style.opacity = '1';
        });

      };

      const nextSlide = () => {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        showSlide(current);

      };

      const prevSlide = () => {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        showSlide(current);

      };

      const startAutoplay = () => {

        autoplay = setInterval(() => {
          nextSlide();
        }, 5000);

      };

      const stopAutoplay = () => {

        clearInterval(autoplay);

      };

      nextBtn?.addEventListener('click', () => {

        stopAutoplay();
        nextSlide();
        startAutoplay();

      });

      prevBtn?.addEventListener('click', () => {

        stopAutoplay();
        prevSlide();
        startAutoplay();

      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();

    }

  }

  /* ==========================================================
     SEARCH PANEL
     ========================================================== */

  const searchBtns = document.querySelectorAll('.luxury-search-btn');
  const searchPanel = document.querySelector('.luxury-search-panel');
  const searchClose = document.querySelector('.luxury-search-panel__close');
  const searchInput = searchPanel?.querySelector('input[type="search"]');

  const openSearch = () => {

    if (!searchPanel) return;

    searchPanel.classList.add('active');
    searchBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));

    window.requestAnimationFrame(() => {
      searchInput?.focus();
    });

  };

  const closeSearch = () => {

    searchPanel?.classList.remove('active');
    searchBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

    const results = searchPanel?.querySelector('[data-search-results]');
    results?.classList.remove('active');

  };

  const toggleSearch = () => {

    if (!searchPanel) return;

    if (searchPanel.classList.contains('active')) {
      closeSearch();
    } else {
      openSearch();
    }

  };

  searchBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {

      event.preventDefault();
      event.stopPropagation();
      toggleSearch();

    });
  });

  searchClose?.addEventListener('click', closeSearch);

  document.addEventListener('click', (event) => {

    if (
      searchPanel &&
      searchPanel.classList.contains('active') &&
      !event.target.closest('.luxury-search-panel') &&
      !event.target.closest('.luxury-search-btn')
    ) {
      closeSearch();
    }

  });

  /* ==========================================================
     SEARCH SUGGESTIONS (PREDICTIVE SEARCH)
     ========================================================== */

  const resultsBox = searchPanel?.querySelector('[data-search-results]');

  if (searchInput && resultsBox) {

    let debounceTimer;
    let currentController;

    const escapeHtml = (str) =>
      String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const renderResults = (data, query) => {

      const products = data?.resources?.results?.products || [];
      const collections = data?.resources?.results?.collections || [];
      const queries = data?.resources?.results?.queries || [];

      if (!products.length && !collections.length && !queries.length) {

        resultsBox.innerHTML =
          `<div class="luxury-search-empty">No results for &ldquo;${escapeHtml(query)}&rdquo;</div>`;

        resultsBox.classList.add('active');
        searchInput.setAttribute('aria-expanded', 'true');

        return;

      }

      let html = '';

      if (queries.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Suggestions</span><ul class="luxury-search-suggestion-list">';

        queries.slice(0, 5).forEach((item) => {
          html += `<li><a href="${item.url}" class="luxury-search-suggestion">${item.styled_text || escapeHtml(item.text)}</a></li>`;
        });

        html += '</ul></div>';

      }

      if (collections.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Collections</span><ul class="luxury-search-suggestion-list">';

        collections.slice(0, 4).forEach((item) => {
          html += `<li><a href="${item.url}" class="luxury-search-suggestion">${escapeHtml(item.title)}</a></li>`;
        });

        html += '</ul></div>';

      }

      if (products.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Products</span><ul class="luxury-search-product-list">';

        products.slice(0, 6).forEach((item) => {

          const image = item.featured_image?.url || item.image || '';

          html += `
            <li>
              <a href="${item.url}" class="luxury-search-product">
                ${image ? `<span class="luxury-search-product-image"><img src="${image}" alt="${escapeHtml(item.title)}" loading="lazy"></span>` : ''}
                <span class="luxury-search-product-info">
                  <span class="luxury-search-product-title">${escapeHtml(item.title)}</span>
                  <span class="luxury-search-product-price">${item.price || ''}</span>
                </span>
              </a>
            </li>
          `;

        });

        html += '</ul></div>';

      }

      resultsBox.innerHTML = html;
      resultsBox.classList.add('active');
      searchInput.setAttribute('aria-expanded', 'true');

    };

    const fetchSuggestions = (query) => {

      if (currentController) {
        currentController.abort();
      }

      currentController = new AbortController();

      const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=10&resources[options][unavailable_products]=last`;

      fetch(url, { signal: currentController.signal })
        .then((res) => res.json())
        .then((data) => renderResults(data, query))
        .catch((err) => {
          if (err.name !== 'AbortError') {
            resultsBox.classList.remove('active');
          }
        });

    };

    searchInput.addEventListener('input', (event) => {

      const query = event.target.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        resultsBox.classList.remove('active');
        resultsBox.innerHTML = '';
        searchInput.setAttribute('aria-expanded', 'false');
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchSuggestions(query);
      }, 300);

    });

    searchInput.addEventListener('focus', () => {

      if (resultsBox.innerHTML.trim() !== '' && searchInput.value.trim().length >= 2) {
        resultsBox.classList.add('active');
      }

    });

  }

  /* ==========================================================
     MOBILE DRAWER
     ========================================================== */

  const drawer = document.querySelector('.luxury-mobile-menu');
  const overlay = document.querySelector('.luxury-mobile-overlay');

  const openBtn =
    document.querySelector('.luxury-hamburger');

  const closeBtn =
    document.querySelector('.luxury-mobile-close');

  /* ==========================================================
     WISHLIST PLACEHOLDER GUARD
     ========================================================== */

  document
    .querySelectorAll('[data-wishlist-placeholder="true"]')
    .forEach((link) => {

      link.addEventListener('click', (event) => {

        event.preventDefault();

        console.warn(
          'Luxury Header: no Wishlist Page URL is set in theme settings, so the wishlist link is disabled. Set one under Header Icons > Wishlist Page URL.'
        );

      });

    });

  const openDrawer = () => {

    if (!drawer) return;

    drawer.classList.add('active');

    overlay?.classList.add('active');

    document.body.classList.add('overflow-hidden');

  };

  const closeDrawer = () => {

    drawer?.classList.remove('active');

    overlay?.classList.remove('active');

    document.body.classList.remove('overflow-hidden');

  };

  openBtn?.addEventListener('click', openDrawer);

  closeBtn?.addEventListener('click', closeDrawer);

  overlay?.addEventListener('click', closeDrawer);

  /* ==========================================================
     ESCAPE KEY SUPPORT
     ========================================================== */

  document.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {
      closeDrawer();
      closeSearch();
    }

  });

  /* ==========================================================
     FOCUS TRAP
     ========================================================== */

  if (drawer) {

    drawer.addEventListener('keydown', (event) => {

      if (event.key !== 'Tab') return;

      const focusable = drawer.querySelectorAll(
        'a, button, input, select, textarea'
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {

        event.preventDefault();
        last.focus();

      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {

        event.preventDefault();
        first.focus();

      }

    });

  }

  /* ==========================================================
     MEGA MENU - FIXED HOVER HANDLING
     ========================================================== */

  const megaMenuItems = document.querySelectorAll('.has-mega-menu');
  let megaMenuHideTimeout;

  megaMenuItems.forEach((item) => {

    const megaMenu = item.querySelector('.luxury-mega-menu');

    if (!megaMenu) return;

    const openMegaMenu = () => {
      clearTimeout(megaMenuHideTimeout);
      item.classList.add('mega-open');
    };

    const closeMegaMenu = () => {
      megaMenuHideTimeout = setTimeout(() => {
        item.classList.remove('mega-open');
      }, 200); // 200ms delay before hiding
    };

    // Open on menu item hover
    item.addEventListener('mouseenter', openMegaMenu);
    item.addEventListener('mouseleave', closeMegaMenu);

    // Open on mega menu hover
    megaMenu.addEventListener('mouseenter', openMegaMenu);
    megaMenu.addEventListener('mouseleave', closeMegaMenu);

  });

  /* ==========================================================
     MEGA MENU CATEGORY SWITCHING
     ========================================================== */

  const categoryItems =
    document.querySelectorAll('.luxury-category-item');

  const panels =
    document.querySelectorAll('.luxury-submenu-panel');

  if (
    categoryItems.length &&
    panels.length
  ) {

    categoryItems.forEach((item) => {

      item.addEventListener('mouseenter', () => {

        const target =
          item.dataset.category;

        categoryItems.forEach((el) => {

          el.classList.remove('is-active');

        });

        panels.forEach((panel) => {

          panel.classList.remove('active');

        });

        item.classList.add('is-active');

        document
          .querySelector(
            `.luxury-submenu-panel[data-panel="${target}"]`
          )
          ?.classList.add('active');

      });

    });

  }

  /* ==========================================================
     TOUCH SUPPORT
     ========================================================== */

  if ('ontouchstart' in window) {

    document
      .querySelectorAll('.has-mega-menu')
      .forEach((item) => {

        const trigger =
          item.querySelector('.luxury-nav-link');

        trigger?.addEventListener('click', (event) => {

          if (
            window.innerWidth > 989 &&
            !item.classList.contains('touch-open')
          ) {

            event.preventDefault();

            document
              .querySelectorAll('.has-mega-menu')
              .forEach((el) => {

                el.classList.remove('touch-open');

              });

            item.classList.add('touch-open');

          }

        });

      });

    document.addEventListener('click', (event) => {

      if (
        !event.target.closest('.has-mega-menu')
      ) {

        document
          .querySelectorAll('.has-mega-menu')
          .forEach((el) => {

            el.classList.remove('touch-open');

          });

      }

    });

  }

  /* ==========================================================
     COLLECTION CARD REVEAL
     ========================================================== */

  const cards =
    document.querySelectorAll(
      '.luxury-collection-card'
    );

  if ('IntersectionObserver' in window) {

    const observer =
      new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('revealed');

            observer.unobserve(entry.target);

          }

        });

      }, {
        threshold: 0.15
      });

    cards.forEach((card) => {

      observer.observe(card);

    });

  }

  /* ==========================================================
     BUTTON RIPPLE EFFECT
     ========================================================== */

  document
    .querySelectorAll(
      '.luxury-action-btn, .luxury-promo-button, #wishlist-icon-bubble'
    )
    .forEach((button) => {

      button.addEventListener('click', (event) => {

        const ripple =
          document.createElement('span');

        ripple.className = 'luxury-ripple';

        const rect =
          button.getBoundingClientRect();

        ripple.style.left =
          event.clientX - rect.left + 'px';

        ripple.style.top =
          event.clientY - rect.top + 'px';

        button.appendChild(ripple);

        setTimeout(() => {
          ripple.remove();
        }, 600);

      });

    });

  /* ==========================================================
     RESIZE HANDLER
     ========================================================== */

  let resizeTimer;

  window.addEventListener('resize', () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {

      if (window.innerWidth > 989) {
        closeDrawer();
      }

    }, 200);

  });

});


/* ============================================================
   LUXURY HEADER — LIVE CART COUNT + CART CLICK BEHAVIOUR
   ============================================================ */
(function () {
  'use strict';

  var CART_BTN = '#luxuryCartBtn';
  var COUNT_EL = '[data-cart-count]';

  function getRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function setCount(count) {
    document.querySelectorAll(COUNT_EL).forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function refreshCount() {
    fetch(getRoot() + 'cart.js?t=' + Date.now(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        maybeReloadCartPage(cart.item_count);
      })
      .catch(function () {});
  }

  /* Cart page ka HTML stale ho to ek baar reload karo */
  function maybeReloadCartPage(count) {
    var isCartPage = /\/cart(\/|\?|$)/.test(window.location.pathname + window.location.search);
    if (!isCartPage) return;

    var rendered = document.querySelectorAll('cart-items .cart-item, .cart-item, [id^="CartItem-"]').length;
    var emptyShown = !!document.querySelector('.cart__empty-text, .is-empty');

    var mismatch = (count > 0 && rendered === 0) || (count > 0 && emptyShown) || (count === 0 && rendered > 0);

    if (mismatch && !sessionStorage.getItem('luxCartReloaded')) {
      sessionStorage.setItem('luxCartReloaded', '1');
      window.location.reload();
    } else if (!mismatch) {
      sessionStorage.removeItem('luxCartReloaded');
    }
  }

  function debouncedRefresh() {
    clearTimeout(window.__luxCartTimer);
    window.__luxCartTimer = setTimeout(refreshCount, 200);
  }

  /* --- 1. Shopify theme events (Dawn / most themes) --- */
  document.addEventListener('cart:updated', debouncedRefresh);
  document.addEventListener('cart:refresh', debouncedRefresh);
  document.addEventListener('cart:change', debouncedRefresh);
  document.addEventListener('cart-drawer:open', debouncedRefresh);
  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, debouncedRefresh);
  }

  /* --- 2. Fallback: koi bhi /cart/add|change|update call hone par --- */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    return origFetch.apply(this, arguments).then(function (res) {
      if (/\/cart\/(add|change|update|clear)/.test(href)) debouncedRefresh();
      return res;
    });
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        debouncedRefresh();
      }
    });
    return origOpen.apply(this, arguments);
  };

  /* --- 3. Back/forward, bfcache, tab wapas aane par sync --- */
  window.addEventListener('pageshow', function () {
    refreshCount();
  });

  window.addEventListener('popstate', refreshCount);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCount();
  });

  window.addEventListener('focus', debouncedRefresh);

  /* --- 4. Cart icon click behaviour --- */

  /* Drawer ka HTML Section Rendering API se refresh karo */
  function refreshDrawerHTML() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve(false);

    return fetch(getRoot() + '?sections=cart-drawer&t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return false;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('cart-drawer');
        if (!fresh) return false;

        drawer.innerHTML = fresh.innerHTML;

        if (fresh.classList.contains('is-empty')) {
          drawer.classList.add('is-empty');
        } else {
          drawer.classList.remove('is-empty');
        }
        return true;
      })
      .catch(function () { return false; });
  }

  function showDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CART_BTN);
    if (!btn) return;
    if (btn.dataset.cartAction !== 'drawer') return; // 'page' → normal link

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // drawer na ho to normal link → cart page

    e.preventDefault();

    refreshDrawerHTML().then(function () {
      showDrawer();
      refreshCount();
    });
  });

  /* --- 5. Cart page ko bfcache me na jane do --- */
  if (/\/cart(\/|\?|$)/.test(window.location.pathname)) {
    window.addEventListener('unload', function () {});
  }

  document.addEventListener('DOMContentLoaded', refreshCount);
  if (document.readyState !== 'loading') refreshCount();
})();